

































import Vue from "vue";
import Component from "vue-class-component";
import { IHeaders } from "./interfaces";
import { targets, maps } from "@/store";
import { ISar } from "@/store/targets/models";
import { MutationTypes } from "@/store/mutations-types";

@Component
export default class SarsTable extends Vue {
  search: string = "";
  headers: IHeaders[] = [
    {
      text: "MMSI",
      align: "start",
      sortable: false,
      value: "mmsi",
    },
    { text: "Nombre", value: "statics.name" },
    { text: "CallSign", value: "statics.callsign" },
    { text: "Velocidad (kn)", value: "speed" },
    { text: "Última actualización", value: "timestamp" },
    { text: "Altitud (m)", value: "alt" },
  ];

  get sars() {
    return targets.getters.sarList;
  }

  handleTimestamp(value: string) {
    return new Date(value).toLocaleTimeString("en-US");
  }

  handleClick(value: ISar) {
    maps.commit(MutationTypes.SET_MAPCENTER, value.position.coordinates);
    const target: ISar = targets.getters.searchSarById(value.mmsi);
    targets.commit(MutationTypes.SET_SELECTED_SAR, target);
  }
}
